import React from 'react'
import Autocomplete from '../../../Shared/AutosuggestV2/Autosuggestv2'
import Select from 'react-select/creatable'
import { isMobile as checkIsMobile } from '../../../../Constants'
import classes from '../../TrucksAvailable.module.css'
import classes1 from './InputFields.module.css'
import '../NewEnquiry.css'
import MultiSelectWithCheckbox from '../../../Shared/MultiSelectCheckbox/MultiSelectCheckbox'

// ===== CONSTANTS =====
const LABEL_STYLE = { fontWeight: 'unset', fontSize: '14px' }

const AUTOCOMPLETE_STYLES = {
  placeholder: (base) => ({ ...base, fontWeight: '500' }),
  input: (base) => ({ ...base, fontWeight: '500' }),
  singleValue: (base) => ({ ...base, fontWeight: '500' }),
  valueContainer: (base) => ({ ...base, padding: '0px 16px' }),
}

const TRUCK_SELECT_STYLES = {
  groupHeading: (base) => ({
    ...base,
    color: 'black',
    fontWeight: 'bold',
    fontSize: '14px',
    textTransform: 'none',
    marginLeft: '10px',
  }),
}

const BLOCKED_KEYS = new Set(['-', 'e', 'E'])

const InputFields = ({
  inputorigin,
  setorigin,
  setinputorigin,
  inputdestination,
  setdestination,
  setinputdestination,
  TruckTypes,
  onChangeTruckTypes,
  selectedTrucks,
  addLanetoProcurement,
  settonnage,
  tonnage,
  capacity,
  setcapacity,
  selectedIndustry,
  setSelectedIndustry,
  materialCategories,
  isRestricted,
  renderMobileExtra,
}) => {
  const mobile = checkIsMobile()
  const companyId = localStorage.getItem('profile_company_id')

  const handleWeightKeyDown = (e) => {
    if (BLOCKED_KEYS.has(e.key)) e.preventDefault()
  }

  const formatTruckLabel = ({ label, isMyTruck }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {isMyTruck && (
        <i
          className="fa fa-truck"
          style={{ marginRight: '8px', color: '#393185', fontSize: '14px' }}
        />
      )}
      <div>{label}</div>
    </div>
  )

  return (
    <form id="input_form" style={{ width: '100%' }}>
      <div className={`row ${classes['s-inputs1']}`} style={{ width: '100%' }}>
        {/* ===== 1. ORIGIN ===== */}
        <div className={classes1[mobile ? 'new-origin1' : 'new-origin']}>
          <label style={LABEL_STYLE}>
            Origin <span className="required-field"> *</span>
          </label>
          <div style={{ width: '100%' }}>
            <Autocomplete
              value={
                inputorigin
                  ? { label: inputorigin, value: inputorigin }
                  : null
              }
              placeholder="Origin"
              className="w-100"
              user_identifier={companyId}
              module_key="indents"
              onChange={(val) => setinputorigin(val)}
              onSelect={(obj) => {
                setorigin(obj)
                setinputorigin(obj?.location_name || obj?.value || '')
              }}
              customStyles={AUTOCOMPLETE_STYLES}
            />
          </div>
        </div>

        {/* ===== 2. DESTINATION ===== */}
        <div className={classes1[mobile ? 'new-origin1' : 'new-destination']}>
          <label style={LABEL_STYLE}>
            Destination <span className="required-field"> *</span>
          </label>
          <div style={{ width: '100%' }}>
            <Autocomplete
              value={
                inputdestination
                  ? { label: inputdestination, value: inputdestination }
                  : null
              }
              placeholder="Destination"
              className="origin"
              user_identifier={companyId}
              module_key="indents"
              onChange={(val) => setinputdestination(val)}
              onSelect={(obj) => {
                setdestination(obj)
                setinputdestination(obj?.location_name || obj?.value || '')
              }}
              customStyles={AUTOCOMPLETE_STYLES}
            />
          </div>
        </div>

        {/* ===== 3. TRUCK TYPE ===== */}
        <div
          className={classes1[mobile ? 'new-origin1' : 'new-trucktype']}
        >
          <label style={LABEL_STYLE}>
            Truck Type <span className="required-field"> *</span>
          </label>
          <label
            className={classes['s-truck-type-select']}
            style={{ width: mobile ? '100%' : '' }}
          >
            <Select
              options={TruckTypes}
              onChange={onChangeTruckTypes}
              value={selectedTrucks}
              className="Truck_Type_Select truck-width"
              classNamePrefix="Truck_Prefix"
              styles={TRUCK_SELECT_STYLES}
              formatOptionLabel={formatTruckLabel}
            />
          </label>
        </div>

        {/* ===== 4. WEIGHT ===== */}
        <div className={classes1[mobile ? 'new-origin1' : 'new-weight']}>
          <label style={LABEL_STYLE}>Weight</label>
          <div
            className={mobile ? classes1['new-weight-row-mobile'] : undefined}
            style={{
              border: '1px solid #dbdbdb',
              height: '49%',
              borderRadius: '3px',
            }}
          >
            <input
              className={`${classes1['new-weight-input']} pl-3`}
              style={{ border: 'none', width: '55%' }}
              placeholder="Weight"
              id="truckWeight"
              type="number"
              value={tonnage}
              onKeyDown={handleWeightKeyDown}
              onChange={(e) => settonnage(e.target.value)}
            />
            <span className={classes1['quatity']}>
              <button
                type="button"
                className={classes1[capacity === 'MT' ? 'MT-select' : 'MT']}
                value="MT"
                onClick={(e) => setcapacity(e.target.value)}
              >
                MT
              </button>
              <button
                type="button"
                className={classes1[capacity === 'KG' ? 'KG-select' : 'KG']}
                value="KG"
                onClick={(e) => setcapacity(e.target.value)}
              >
                KG
              </button>
            </span>
          </div>
        </div>

        {/* ===== 5. PRODUCT TYPE ===== */}
        <div className={classes1[mobile ? 'new-origin1' : 'new-weight']}>
          <label style={LABEL_STYLE}>Product Type</label>
          <MultiSelectWithCheckbox
            options={materialCategories}
            onChange={(e) => setSelectedIndustry(e)}
            value={selectedIndustry}
          />
        </div>

        {/* ===== ADD LANE BUTTON ===== */}
        {mobile ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', marginTop: '12px', flexWrap: 'nowrap' }}>

            {renderMobileExtra && <div style={{ flex: 1, minWidth: 0 }}>{renderMobileExtra}</div>}
            <button
              type="button"
              className={classes1['new-plus-mobile']}
              disabled={isRestricted}
              style={{
                cursor: isRestricted ? 'not-allowed' : 'pointer',
                opacity: isRestricted ? 0.6 : 1,
              }}
              onClick={addLanetoProcurement}
            >
              <i className="fa fa-plus" />
            </button>
          </div>
        ) : (
          <button
            type="button"
            className="btn btn-sm position-absolute"
            disabled={isRestricted}
            style={{
              top: '15%',
              left: '91%',
              cursor: isRestricted ? 'not-allowed' : 'pointer',
              opacity: isRestricted ? 0.6 : 1,
            }}
            onClick={addLanetoProcurement}
          >
            <i
              style={{ fontSize: '230%', marginTop: '48%' }}
              className={`fa fa-plus-circle ${classes['s-icon1']}`}
            />
          </button>
        )}
      </div>
    </form>
  )
}

export default InputFields